import { Spin } from 'antd';
import { Suspense, lazy } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import Layout from '../../../components/Layout';
import Menu from '../../../components/Layout/Menu';

const UserProfileContent = lazy(() => import('../../../components/Pages/Users/[userId]'));

export default function UserProfile(): JSX.Element | null {
  document.title = `${process.env.REACT_APP_TITLE}: User Profile page`;

  return (
    <Layout LeftMenu={Menu} transparent>
      <Suspense fallback={<Spin spinning indicator={<LoadingOutlined spin />} />}>
        <UserProfileContent />
      </Suspense>
    </Layout>
  );
}
